import * as React from "react";
import type { SVGProps } from "react";
const SvgChurch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 20h-2v-3.59l.29.29a.996.996 0 1 0 1.41-1.41l-7.71-7.71V5.99h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1.59l-7.7 7.71A.996.996 0 1 0 4.7 16.7l.29-.29V20H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1M7 14.41l5-5 5 5V20h-2v-3c0-1.65-1.35-3-3-3s-3 1.35-3 3v3H7zM13 20h-2v-3c0-.55.45-1 1-1s1 .45 1 1z"
    />
  </svg>
);
export default SvgChurch;
